._sectionView_aff3l_1 {
  display: flex;
  align-items: center;
  flex-direction: column; }
